<template>
     <div class="listing-collections" style="margin-top: 45px; display: none;" v-if="productTerm?.jumpLinks && productTerm?.jumpLinks.enable">
       <swiper :free-mode="true" :spaceBetween="20" :slidesPerView="'auto'" :modules="modules" class="listing-swiper">
         <swiper-slide v-for="(item, jumLinkKey) in productTerm?.jumpLinks.jumplinks" :key="jumLinkKey">
         <div class="listing-collection-items">
            <ListingCollectionItem :icon="item.icon" :src="item.link" :name="item.title" />
         </div>
         </swiper-slide>
       </swiper>
     </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { FreeMode,Pagination } from "swiper/modules";
import ListingCollectionItem from "./ListingCollectionItem.vue";
const modules = [FreeMode,Pagination];
interface IProps {
  productTerm: any
}
const props = defineProps<IProps>();
</script>